<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <Bienvenida />
      </v-col>
    </v-row>
    <div v-if="loading">
      <InformeCardLoader />
    </div>
    <div v-else>
      <v-row v-for="(row, rowIndex) in Math.ceil(charts.length / 2)" :key="rowIndex">
        <v-col v-for="(chart, colIndex) in charts.slice(rowIndex * 2, (rowIndex * 2) + 2)" :key="colIndex" sm="12" md="6">
          <InformeCard :chart="chart" />
        </v-col>
      </v-row>
    </div>
    <ChatClaudia :chatClaudia="chatClaudia" @cerrar="cerrarChat()" @insertGeneratedChart="insertGeneratedChart"/>
    <v-speed-dial
      fixed
      style="bottom: 37px; right: 30px;"
    >
      <template v-slot:activator>
        <v-btn
          color="teal lighten-1"
          dark
          fab
          @click="chatClaudia = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-speed-dial>
  </v-container>
</template>

<script>
  import Bienvenida from '../../components/informes/Bienvenida.vue';
  import InformeCard from '../../components/informes/InformeCard.vue';
  import InformeCardLoader from '../../components/informes/InformeCardLoader.vue';
  import ChatClaudia from '../../components/chatClaudia/ChatClaudia.vue';
  import { clearChat } from '@/api/claudia'
  import { getInformes } from '@/api/informes'
  export default {
    name: "InformesIndex",
    components: {
        Bienvenida, InformeCard, InformeCardLoader, ChatClaudia
    },
    data() {
      return {
        loading: false,
        chatClaudia: false,
        charts: [],
      }
    },
    mounted(){
      this.loading = true;
      getInformes().then( respuesta => {
        // console.log(respuesta.data)
        console.log(this.charts)
        this.charts = respuesta.data;
        console.log(this.charts)
      }).finally(() => {
        this.loading = false;
      })
    },
    methods: {
      insertGeneratedChart(chart){
        this.charts.push(chart)
      },
      cerrarChat(){
        this.chatClaudia = false
        clearChat();
      }
    }
  }
</script>
